// extracted by mini-css-extract-plugin
module.exports = {"root":"_30980","content":"_39xj2","thumbnail":"_1nhPP","empty":"_1C2Wx","loader":"_2NBtr","loading":"_2AdKl","title":"MyOnU","description":"_1S84b"};